import { BRAND_KINDS, brandKindCopy, type BrandKind } from './brandKind';

interface KindStepProps {
  /** True on the add-a-brand path, where the lede says so. */
  isAdditional: boolean;
  onPick: (kind: BrandKind) => void;
  onBack?: () => void;
}

/**
 * The first question: is this content for a business, or for you?
 *
 * The answer never changes the tables; it changes what they are called and
 * how the pipeline speaks. A personal brand's knowledge base is filled with
 * what you are known for, your credentials and your offers, and the copy is
 * written in the first person. A business's is unchanged from before.
 */
export function KindStep({ isAdditional, onPick, onBack }: KindStepProps) {
  return (
    <section className="wizard">
      <div className="wizard__step">
        <h2 className="wizard__title">
          {isAdditional ? 'What is the new brand?' : 'What are we writing for?'}
        </h2>
        <p className="wizard__lede">
          A business speaks as the business. A personal brand is you: the brand profile is about you
          and every post is written in the first person. You can hold several brands on one account
          and switch between them.
        </p>

        <div className="brief-choice">
          {BRAND_KINDS.map((kind) => {
            const copy = brandKindCopy(kind);
            return (
              <button
                className="brief-choice__card"
                type="button"
                key={kind}
                onClick={() => onPick(kind)}
              >
                <span className="brief-choice__title">{copy.card.title}</span>
                <span className="brief-choice__body">{copy.card.body}</span>
              </button>
            );
          })}
        </div>
      </div>

      {onBack ? (
        <div className="wizard__actions">
          <button className="button button--ghost" type="button" onClick={onBack}>
            Cancel
          </button>
        </div>
      ) : null}
    </section>
  );
}
